<div class="wrapper">
  <div class="frame">
    <div class="closing">
      <i class="fas fa-times" (click)="onClose()"></i>
    </div>
    <div class="row search-user">
      <div class="fontsearch">
        <input
          class="form-control"
          type="text"
          name="search"
          [(ngModel)]="searchText"
          autocomplete="off"
          placeholder="Start searching for a user by name or role"
        />
        <i class="fa fa-search"></i>
      </div>
    </div>
    <div class="parent">
      <div class="users-col">
        <div class="col-5 card" *ngFor="let user of users | filter: searchText">
          <div class="username">
            {{ user.firstName }} {{ user.lastName
            }}<span *ngIf="user.lockoutEnabled" class="big-red-exclamation-mark"
              >!</span
            >
          </div>
          <div class="roles">
            <span *ngFor="let role of user.roles; let last = last">
              {{ role.roleName }}<span *ngIf="!last">,</span>
            </span>
          </div>
          <div class="actions">
            <span class="btn-group pl-2">
              <div
                (click)="assignSurveyToSurveyor(user)"
                data-toggle="modal"
                class="btn-image"
              >
                <mat-icon>check_circle</mat-icon>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
